export default __webpack_public_path__ + "d8b93c75a5f6f16cbab82a85eea18c7e.svg";